import React, { useState } from 'react'
import UIImage from 'material-ui-image'

import { Box, Dialog, DialogContent } from '@material-ui/core'

interface ImageProps {
  src: string
  width?: string
  height?: string
}

export const Image = (props: ImageProps) => {
  const { src, width = '5rem', height = '5rem' } = props
  const [open, setOpen] = useState(false)

  return (
    <Box style={{ width, height }}>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg" fullWidth>
        <DialogContent>
          <UIImage src={src} />
        </DialogContent>
      </Dialog>
      {src ? (
      <UIImage src={src} aspectRatio={1} cover={true} onClick={() => setOpen(true)} />
      ) : (
        <Box style={{ width, height }}>
          -
        </Box>
      )}
    </Box>
  )
}
